import { render, staticRenderFns } from "./official-documents.vue?vue&type=template&id=0f210445&scoped=true&"
import script from "./official-documents.vue?vue&type=script&lang=js&"
export * from "./official-documents.vue?vue&type=script&lang=js&"
import style0 from "./official-documents.vue?vue&type=style&index=0&id=0f210445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f210445",
  null
  
)

export default component.exports